export default "assets/images/icons/doc-922e7627.svg";